import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../../services/AuthService';
import { setAuth } from '../../../util/Auth';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setIsSubmitting(true);

        try {
            const { accessToken, token, user } = await login(email, password);
            setAuth(accessToken, token, user.uuid);
            navigate('/');
        } catch (loginError) {
            setError(loginError instanceof TypeError ? 'Unable to connect to the login service.' : loginError.message);
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div className="login-container">
            <div className="login-form-container">
                <div className="login-brand">
                    <div className="brand-logo">SADIDA</div>
                    <div className="brand-admin">Admin</div>
                </div>
                <form onSubmit={handleLogin} className="login-form">
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="login-input"
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="login-input"
                    />
                    {error && <div className="login-error" role="alert">{error}</div>}
                    <button type="submit" className="login-button" disabled={isSubmitting}>
                        {isSubmitting ? 'Logging in...' : 'Login'}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default Login;
